import { render, staticRenderFns } from "./AccessLogsPage.vue?vue&type=template&id=071256b9&scoped=true&"
import script from "./AccessLogsPage.vue?vue&type=script&lang=js&"
export * from "./AccessLogsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071256b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071256b9')) {
      api.createRecord('071256b9', component.options)
    } else {
      api.reload('071256b9', component.options)
    }
    module.hot.accept("./AccessLogsPage.vue?vue&type=template&id=071256b9&scoped=true&", function () {
      api.rerender('071256b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AccessLogsPage.vue"
export default component.exports